import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import trans from "../../../utils";
import Actions from "../../antd/Table/Actions";
import AntdTable from "../../antd/Table/Table";
import { filtrationcontext } from "../../../context/Filtercontext";
import { popupcontext } from "../../../context/Popupscontext";
import { formatDateString } from "../../../JsHelpers/DateFormat";
import RolesHead from "./RolesParts/RolesHead";
import RolesForms from "./RolesForms/RolesForms";
import { useGetAllRolesQuery } from "../../../Redux/service/Roles&Permissions/RolesPermissions";
import { Tag } from "antd";
import Loader from "../../Helpers/Loader/Loader";
import usePermission from "../../../hooks/usePermission";
import AssignRolePopup from "../../Users/UsersPopUp/AssignRolePopup";

export default function Roles() {
	const { deleteItem, setDeleteItem, setReloadData, reloadData } =
		useContext(popupcontext);
	const { create, edit, delete: canDelete } = usePermission("SETUPUSERROLES");

	const [currentPage, setCurrentPage] = useState(1);
	const [sort, setSort] = useState({
		by: "",
		order: "",
	});
	const buildQueryString = (filterObj) => {
		const query = Object.entries(filterObj)
			.filter(
				([_, value]) => value !== null && value !== "" && value !== undefined,
			)
			.map(([key, value]) => `${key}=${value}`)
			.join("&");

		return query ? `?${query}` : "";
	};
	const [filter, setFilter] = useState({
		accessType: null,
		tc_role: null,
		isActive: null,
	});

	const queryString = buildQueryString(filter);
	const {
		limit,
		setLimit,
		setSort: SetSortFilter,
		searchQuery,
		setSearchQuery,
	} = useContext(filtrationcontext);
	const {
		data: RolesData,
		refetch,
		isLoading,
	} = useGetAllRolesQuery(
		{
			page: currentPage,
			limit: limit,
			search: searchQuery,
			sortby: sort.by,
			order: sort.order,
			queryString: queryString,
		},
		{
			skip: !currentPage || !limit,
		},
	);
	console.log("RolesData", RolesData);
	useEffect(() => {
		localStorage.setItem("page", currentPage);
	}, [currentPage]);
	useEffect(() => {
		if (reloadData) {
			refetch();
		}
		setReloadData(false);
	}, [reloadData]);
	useEffect(() => {
		return () => {
			SetSortFilter({ type: "", value: "" });
			setSearchQuery("");
		};
	}, [SetSortFilter, setSearchQuery]);
	useEffect(() => {
		if (deleteItem.condition === true && deleteItem.value === "role") {
			refetch();
			if (RolesData?.data.length === 1 && currentPage > 1) {
				setCurrentPage(currentPage - 1);
				localStorage.setItem("page", currentPage);
			}
			setDeleteItem({ condition: null, value: null });
		}
	}, [
		currentPage,
		deleteItem.condition,
		deleteItem.value,
		refetch,
		setDeleteItem,
		RolesData?.data,
	]);
	const handleTableChange = (pagination, filters, sorter) => {
		if (sorter.order) {
			setSort({
				by: sorter.field,
				order: sorter.order === "ascend" ? "asc" : "desc",
			});
		} else {
			setSort({
				by: "",
				order: "",
			});
		}
	};
	useEffect(() => {
		setCurrentPage(1);
	}, [searchQuery]);
	const userTypeColor = (modules) => {
		if (modules === "SUPERVISOR") {
			return "orange";
		} else if (modules === "CUSTOMER") {
			return "blue";
		} else if (modules === "FIELD_STAFF") {
			return "green";
		}
	};
	const rolesColumns = [
		{
			title: trans("Name"),
			dataIndex: "name",
			sorter: true,
			fixed: "left", // ✅ fix to the left
			key: "name",
			width: 150, // ✅ must give width when fixed
			render: (name) => <span>{name}</span>,
		},
		{
			title: trans("Description"),
			dataIndex: "description",
			key: "description",
			width: 250,
			render: (description) => <span>{description || "- - - - -"}</span>,
		},
		{
			title: trans("User Type"),
			sorter: true,
			dataIndex: "userType",
			key: "userType",
			width: 150,
			render: (userType) => (
				<Tag color={userTypeColor(userType)} className="text-capitalize">
					{trans(userType?.replace(/_/g, " "))}
				</Tag>
			),
		},
		{
			title: trans("Permissions"),
			dataIndex: "rolePermissions",
			key: "rolePermissions",
			width: 150,
			render: (rolePermissions) => {
				return (
					<Tag color="default">{`${rolePermissions?.length} ${trans(
						"Permissions",
					)}`}</Tag>
				);
			},
		},
		// {
		// 	title: trans("Hierarchy Level"),
		// 	dataIndex: "tc_role",
		// 	sorter: true,
		// 	key: "tc_role",
		// 	width: 200,
		// 	render: (tc_role) => <span>{trans(tc_role)}</span>,
		// },
		{
			title: trans("Status"),
			key: "isActive",
			sorter: true,
			dataIndex: "isActive",
			render: (isActive) => {
				return (
					<Tag color={isActive ? "green" : "red"}>
						{isActive ? trans("Active") : trans("Inactive")}
					</Tag>
				);
			},
		},
		{
			title: trans("Expiration Date"),
			sorter: true,
			dataIndex: "expiry",
			key: "expiry",
			width: 200,
			render: (expiry) => <span>{formatDateString(expiry)}</span>,
		},
		{
			title: trans("Created By"),
			sorter: true,
			dataIndex: "createdBy",
			key: "createdBy",
			width: 180,
			render: (createdBy) => <span>{createdBy?.name}</span>,
		},
		{
			title: trans("Created At"),
			sorter: true,
			dataIndex: "createdAt",
			key: "createdAt",
			width: 200,
			render: (createdAt) => <span>{formatDateString(createdAt)}</span>,
		},
		{
			title: trans("Actions"),
			key: "actions",
			fixed: "right", // ✅ fix to the right
			width: 120, // ✅ must give width when fixed
			render: (_, record) => (
				<Actions
					roleId={record.id}
					name={record.name}
					type="roles"
					assignrole="assignrole"
					canAddTask={create}
					canEdit={edit}
					canDelete={canDelete}
				/>
			),
		},
	];

	return (
		<div className="users">
			<Helmet>
				<title>Roles</title>
				<meta name="description" content="Users" />
			</Helmet>
			<RolesHead setFilter={setFilter} setCurrentPage={setCurrentPage} />
			{isLoading ? (
				<>
					<div className="loader-container loader-table">
						<Loader />
					</div>
				</>
			) : (
				<div className="bg-white-rounded-top table-parent">
					<AntdTable
						columns={rolesColumns}
						dataSource={RolesData?.data || []}
						loading={isLoading}
						pageSize={limit}
						totalItems={RolesData?.totalResults || 0} // Total count for pagination
						currentPage={currentPage}
						onPageChange={(page) => setCurrentPage(page)}
						onLimitChange={(newLimit) => {
							setLimit(newLimit);
							setCurrentPage(1);
						}}
						onTableChange={handleTableChange}
					/>
				</div>
			)}
			<AssignRolePopup />

			<RolesForms />
		</div>
	);
}
